var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.8011 9.95002H8.10107V7.75002C8.10107 7.44697 8.34802 7.20002 8.65107 7.20002H9.20107V7.75002C9.20107 8.05252 9.44857 8.30002 9.75107 8.30002C10.0536 8.30002 10.3011 8.05252 10.3011 7.75002V7.20002H13.6011V7.75002C13.6011 8.05252 13.8486 8.30002 14.1511 8.30002C14.4536 8.30002 14.7011 8.05252 14.7011 7.75002V7.20002H15.2511C15.5541 7.20002 15.8011 7.44697 15.8011 7.75002V9.95002ZM14.1489 13.25H11.9489C11.6464 13.25 11.3989 13.0025 11.3989 12.7C11.3989 12.3975 11.6464 12.15 11.9489 12.15H14.1489C14.4514 12.15 14.6989 12.3975 14.6989 12.7C14.6989 13.0025 14.4514 13.25 14.1489 13.25ZM9.74857 13.25C9.44607 13.25 9.19857 13.0025 9.19857 12.7C9.19857 12.3975 9.44607 12.15 9.74857 12.15C10.0511 12.15 10.2986 12.3975 10.2986 12.7C10.2986 13.0025 10.0511 13.25 9.74857 13.25ZM15.25 6.1H14.7V5.55C14.7 5.2475 14.4525 5 14.15 5C13.8475 5 13.6 5.2475 13.6 5.55V6.1H10.3V5.55C10.3 5.2475 10.0525 5 9.75 5C9.4475 5 9.2 5.2475 9.2 5.55V6.1H8.65C7.7403 6.1 7 6.8403 7 7.75V14.35C7 15.2597 7.7403 16 8.65 16H15.25C16.1597 16 16.9 15.2597 16.9 14.35V7.75C16.9 6.8403 16.1597 6.1 15.25 6.1Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }